module.exports = __webpack_public_path__ + "static/media/b-icon.de402e0d.svg";